import React from 'react';
import { Grid, Tooltip, IconButton } from '@material-ui/core';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { globalAssoSearchListingTypeEntity } from '../../constants/applicationConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CustomListing from '../../components/customListing/CustomListing';
import ImportFilterSection from '../../components/filterSections/ImportFilterSection';
import ImportPreviewDialog from '../../components/importPreviewDialog/importPreviewDialog';
import ImportResultsPage from '../importResults/importResults';
import { PopupModal } from '../../submodule';
import ImportFormFields from './importFormFields/importFormFields';
import { stringConstants } from '../../constants/stringConstants';

const useStyles = makeStyles({
  filterContainer: {
    padding: '30px 20px 10px 20px',
    fontSize: '20px',
    fontWeight: '600',
  },
  filterIconPopover: {
    border: '2px solid #A9A9A9',
    borderRadius: '15px 0px 15px 15px',
  },
  filterOptionsBox: {
    padding: '20px',
    background: '#EDEDED',
    minWidth: '500px',
  },
  btnCloseFiltersPopover: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '0',
    paddingRight: '0',
  },
  paginationBox: {
    margin: '30px 0',
  },
});

const ImportPage = (props) => {
  const classes = useStyles();
  const importAction = useStoreActions((actions) => actions.import);
  const importState = useStoreState((state) => state.import);
  const commonAction = useStoreActions((actions) => actions.common);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [tableData, setTableData] = React.useState(false);

  const [keywordsFilter, setKeywordsFilter] = React.useState('');
  const [statusFilter, setStatusFilter] = React.useState(null);
  const [paHandlingFilter, setPaHandingFilter] = React.useState([]);
  const [filtersApplied, setFiltersApplied] = React.useState(false);
  const [recordTypeFilter, setRecordTypeFilter] = React.useState('all');
  const userState = useStoreState((state) => state.userList);

  // Local State for the opening/closing Import Preview Dialog
  const [open, setOpen] = React.useState(false);
  const [isOpenAdd, setIsOpenAdd] = React.useState(false);
  const [previewData, setPreviewData] = React.useState([]);
  const [randomNumber, setRandomNumber] = React.useState(0);
  const [openImporResults, setOpenImporResults] = React.useState(false);
  const [selectedJobID, setSelectedJobID] = React.useState('');

  const [fromDateFilter, setFromDateFilter] = React.useState('');
  const [toDateFilter, setToDateFilter] = React.useState('');

  const [importTypeFilter, setImportTypeFilter] = React.useState('all');
  const [importStatusFilter, setImportStatusFilter] = React.useState('all');

  const handlingLabel = '';
  const handlingOptions = [];

  const recordTypesFilterLabel = 'Type';
  const recordTypesFilterOptions = [].sort(function (a, b) {
    var textA = a.value.toUpperCase();
    var textB = b.value.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  function resetFilters() {
    setImportTypeFilter('all')
    setImportStatusFilter('all')
  }

  const importJob = () => {
    try {
      importAction
        .importJob(previewData.job_id)
        .then(function (response) {
          // setDisableImport(true);
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.importJobProcessingRedirectMsg,
          });
          importAction.getJobList();
          setTimeout(() => {
            // Redierecting to the Job listing Page
            setIsOpenAdd(false);
          }, 2000);
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: error.response.data.error,
              error: true,
            });
          }
        });
    } catch (err) {
      //
    }
  };

  // Download File from S3 Bucket
  const downloadFile = (resultFilePath) => {
    const file = resultFilePath;
    importAction
      .getPreSignedUrl({
        filename: file,
        operation_type: 'DOWNLOAD',
      })
      .then(function (response) {
        window.open(response.data.data.url);
      })
      .catch(function (error) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: stringConstants.fileDownloadFailureMsg,
          error: true,
        });
      });
  };

  // Download import sample files
  const downloadSampleFiles = () => {
    importAction
      .downloadSampleFiles()
      .then(function (response) {
        let fileName = 'sample-files.zip'; 
        let mimeType = 'application/zip';
        let blob;
        if (typeof response.data === 'string' && response.data.startsWith('UEs')) {
          const byteCharacters = atob(response.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          blob = new Blob([byteArray], { type: mimeType });
        } else {
          blob = new Blob([response.data], { type: mimeType });
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 100);
      })
      .catch(function (error) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: stringConstants.fileDownloadFailureMsg,
          error: true,
        });
      });
  };

  /** For filtering the data */
  React.useEffect(() => {
    if (importState.jobList && importState.jobList.length > 0) {
      let filteredData = [...importState.jobList];

      let lowercasedSearchInput = keywordsFilter.trim().toLowerCase();

      filteredData = filteredData.filter((item) => {
        return lowercasedSearchInput.length > 0
          ? item.title &&
              item.title?.toLowerCase().includes(lowercasedSearchInput)
          : true;
      });

      if (
        importTypeFilter &&
        importTypeFilter.length > 0 &&
        importTypeFilter != 'all'
      ) {
        filteredData = filteredData.filter((item) => {
          return (
            item.import_type_title &&
            importTypeFilter.toLowerCase() ==
              item.import_type_title.toLowerCase()
          );
        });
      }

      if (
        importStatusFilter &&
        importStatusFilter.length > 0 &&
        importStatusFilter != 'all'
      ) {
        filteredData = filteredData.filter((item) => {
          return (
            item.current_status &&
            importStatusFilter.toLowerCase() ==
              item.current_status.toLowerCase()
          );
        });
      }

      if (fromDateFilter != '') {
        let fromDate = moment(fromDateFilter);
        if (fromDate.isValid()) {
          filteredData = filteredData.filter((item) => {
            return item.create_date >= fromDate.format('YYYY-MM-DD HH:mm:ss');
          });
        }
      }

      if (toDateFilter != '') {
        let toDate = moment(toDateFilter);
        if (toDate.isValid()) {
          filteredData = filteredData.filter((item) => {
            return item.create_date <= toDate.format('YYYY-MM-DD HH:mm:ss');
          });
        }
      }

      setTableData(filteredData);
    }
  }, [
    keywordsFilter,
    importTypeFilter,
    importStatusFilter,
    fromDateFilter,
    toDateFilter,
  ]);

  function isPAChecked(title) {
    return paHandlingFilter.includes(title);
  }

  /** Handle the PA Handling checkboxes in Filters box  */
  function handlePAFilter(event) {
    const paItems = [...paHandlingFilter];

    if (event.target.checked) {
      paItems.push(event.target.value);
    } else {
      let index = paItems.indexOf(event.target.value);
      if (index > -1) {
        paItems.splice(index, 1);
      }
    }

    setPaHandingFilter(paItems);
    setFiltersApplied(true);
  }

  /** Handle the keywords filter input change  */
  function handleKeywordsChange(event) {
    setKeywordsFilter(event.target.value);
    setFiltersApplied(true);
  }

  function handleImportTypeFilter(event) {
    setImportTypeFilter(event.target.value);
    setFiltersApplied(true);
  }

  function handleImportStatusFilter(value) {
    setImportStatusFilter(value);
    setFiltersApplied(true);
  }

  /** Handle the Status Switch in Filters box */
  function handleStatusToggle(event) {
    setStatusFilter(event.target.value);
    setFiltersApplied(true);
  }

  function handleTypesFilterChange(event) {
    setRecordTypeFilter(event.target.value);
  }

  function handleFilterIconClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseFilterBox() {
    setAnchorEl(null);
  }

  //Click add form
  const addFormPopupHandler = (type, row = null) => {
    if (type === 'preview_result') {
      setOpenImporResults(true);
      setSelectedJobID(row.PK);
    }
  };

  React.useEffect(() => {
    importAction.setJobListLoader(true);
    importAction.getJobList();
    importAction.getImportTypes();
  }, []);

  React.useEffect(() => {
    // Defaults is active records
    setTableData(importState.jobList);
  }, [importState.jobList]);

  const newImportHandler = () => {
    setIsOpenAdd(true);
  };

  const startImport = (jobId) => {
    try {
      importAction
        .importJob(jobId)
        .then(function (response) {
          importState.jobList &&
            importState.jobList.filter((item) => {
              if (item.PK === jobId) {
                item.current_status = 'QUEUED';
              }
              return item;
            });
          importAction.setJobList(importState.jobList);
          setRandomNumber(Math.random()); // NOSONAR
           setTimeout(() => {
            // Redierecting to the Job listing Page
            setIsOpenAdd(false);
          }, 1000);
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.importJobProcessingMsg,
          });
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: error.response.data.error,
              error: true,
            });
          }
        });
    } catch (err) {
      //
    }
  };

  const processResponseData = (data) => {
    let dataObject = {
      columns: [],
      data: [],
    };
    let preview = data.preview;
    try {
      for (let i = 0; i < preview.length; i++) {
        let record = preview[i];
        let rowObject = {};
        for (let j = 0; j < record.length; j++) {
          let title = record[j].title;
          if (i === 0) {
            dataObject.columns.push({
              Header: title,
              field: title,
              width: 250,
            });
          }
          rowObject[title] = record[j].value === '' ? ' - ' : record[j].value;
        }
        rowObject['id'] = i;
        dataObject.data.push(rowObject);
      }
    } catch (error) {
      console.log('Error while formatting preview data ', error);
    }
    return dataObject;
  };

  // Start the Prview Process
  const previewAgain = (jobId) => {
    try {
      importAction
        .previewAgain(jobId)
        .then(function (response) {
          let formattedGridData = processResponseData(response.data.data);
          response.data.data['formattedGridData'] = formattedGridData;
          setPreviewData(response.data.data);
          setOpen(true);
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error_message
          ) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: error.response.data.error_message,
              error: true,
            });
          } else {
            console.log('error while fetching data ', error);
            commonAction.setSubmitSnackbar({
              status: true,
              messages: stringConstants.NetWorkError,
              error: true,
            });
          }
        });
    } catch (err) {
      console.log('error while fetching data ', err);
      commonAction.setSubmitSnackbar({
        status: true,
        messages: stringConstants.NetWorkError,
        error: true,
      });
    }
  };

  //close Preview Import dialog popup
  const handleClose = async (response) => {
    try {
      setOpen(false);
      if (response) {
        setIsOpenAdd(false);
        startImport(response);
      }
    } catch (err) {
      console.log('error while processing import request ', err);
    }
  };

  return (
    <Grid container direction="row">
      <DisplayBreadcrumbs
        items={[
          {
            title: 'Import',
            link: '/import',
          },
        ]}
      />

      <Grid container direction="row" style={{ marginBottom: '50px' }}>
        <Grid container>
          <Grid item md={12} className={classes.filterContainer}>
            <Grid container>
              <Grid item md={4} style={{ display: 'flex' }} alignItems="center">
                Import &nbsp;&nbsp;
              </Grid>

              <ImportFilterSection
                statusFilter={statusFilter}
                keywordsFilter={keywordsFilter}
                anchorEl={anchorEl}
                isPAChecked={isPAChecked}
                handlePAFilter={handlePAFilter}
                handleKeywordsChange={handleKeywordsChange}
                handleStatusToggle={handleStatusToggle}
                handleFilterIconClick={handleFilterIconClick}
                handleCloseFilterBox={handleCloseFilterBox}
                setKeywordsFilter={setKeywordsFilter}
                recordTypeFilter={recordTypeFilter}
                setRecordTypeFilter={setRecordTypeFilter}
                handlingOptions={handlingOptions}
                handlingLabel={handlingLabel}
                recordTypesFilterLabel={recordTypesFilterLabel}
                recordTypesFilterOptions={recordTypesFilterOptions}
                handleTypesFilterChange={handleTypesFilterChange}
                textApproved="In Patient"
                textDraft="Out Patient"
                keywordsPlaceholder="Enter Import Job Name"
                fromDateFilter={fromDateFilter}
                setFromDateFilter={setFromDateFilter}
                toDateFilter={toDateFilter}
                setToDateFilter={setToDateFilter}
                importTypeFilter={importTypeFilter}
                handleImportTypeFilter={handleImportTypeFilter}
                importStatusFilter={importStatusFilter}
                handleImportStatusFilter={handleImportStatusFilter}
                importTypes={importState.importTypes}
                setFiltersApplied={setFiltersApplied}
                resetFilters={resetFilters}
              />

              <Grid
                item
                md={4}
                alignItems="center"
                justifyContent="flex-end"
                style={{ display: 'flex' }}
              >
                <Tooltip title="New Import">
                  <IconButton
                    color="primary"
                    aria-label="Add"
                    onClick={newImportHandler}
                  >
                    <AddBoxIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Download Import Samples">
                  <IconButton
                    color="primary"
                    aria-label="Download"
                    onClick={downloadSampleFiles}
                  >
                    <CloudDownloadIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>

          {previewData.formattedGridData && (
            <ImportPreviewDialog
              previewData={previewData}
              open={open}
              onClose={handleClose}
            />
          )}

          <CustomListing
            tableData={tableData}
            isLoaded={false}
            entityType={globalAssoSearchListingTypeEntity.import}
            filtersApplied={filtersApplied}
            setFiltersApplied={setFiltersApplied}
            addFormPopupHandler={addFormPopupHandler}
            randomNumber={randomNumber}
            startImport={startImport}
            previewAgain={previewAgain}
            downloadFile={downloadFile}
          />

          {openImporResults && (
            <ImportResultsPage
              open={openImporResults}
              onCloseDialog={() => {
                setOpenImporResults(false);
              }}
              selectedJobID={selectedJobID}
            />
          )}
          <PopupModal open={isOpenAdd}>
            <Grid container direction="column">
              <Grid item md={12} xs={12}>
                <ImportFormFields
                  history={props.history}
                  formValues={userState.user}
                  isProcImport={true}
                  onDone={(data) => {
                    setPreviewData(data);
                  }}
                  cancelClick={(data) => {
                    if (data === 'preview') {
                      setOpen(true);
                    } else {
                      setIsOpenAdd(false);
                    }
                  }}
                  importJob={importJob}
                />
              </Grid>
              {open && (
                <ImportPreviewDialog
                  previewData={previewData}
                  open={open}
                  onClose={handleClose}
                />
              )}
            </Grid>
          </PopupModal>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ImportPage;
